import React from "react";
import SectionHead from "../ui/SectionHead";
import Reveal from "../ui/Reveal";
import { Clock, Activity, Lock } from "../ui/Icons";
import "./About.css";

const PRINCIPLES = [
  {
    icon: Clock,
    title: "24/7 automated supervision",
    text: "Our systems act as digital overseers: always watching, never fatigued, escalating only what matters.",
  },
  {
    icon: Activity,
    title: "Insights, not footage",
    text: "We turn raw visual data into events, metrics and alerts that plug straight into how your operation already runs.",
  },
  {
    icon: Lock,
    title: "Built for enterprise infrastructure",
    text: "On-premise or cloud, privacy by design, integrated with the cameras, VMS and IT policies you already have.",
  },
];

export default function About() {
  return (
    <section id="about" className="section about">
      <div className="container about__grid">
        <Reveal className="ety card">
          <span className="eyebrow eyebrow--plain">The name</span>
          <div className="ety__row">
            <span className="ety__word ety__word--gr">ἐπί</span>
            <span className="ety__def mono">
              epi — <i>over, upon</i>
            </span>
          </div>
          <span className="ety__plus" aria-hidden="true">
            +
          </span>
          <div className="ety__row">
            <span className="ety__word ety__word--gr">σκοπός</span>
            <span className="ety__def mono">
              skopos — <i>watcher</i>
            </span>
          </div>
          <div className="ety__eq">
            <span className="ety__eqsign mono">=</span>
            <span className="ety__result">
              Episcope. <em>The one who watches over.</em>
            </span>
          </div>
          <span className="ety__tag mono">Decoding vision, defining possibilities</span>
        </Reveal>

        <div className="about__copy">
          <SectionHead
            eyebrow="Why Episcope"
            title="Intelligent monitoring that watches over your operations."
            lead="We combine cutting-edge computer vision with deep learning to create intelligent oversight systems that transform raw visual data into actionable insights for modern enterprises."
          />
          <ul className="principles">
            {PRINCIPLES.map((p, i) => (
              <Reveal as="li" key={p.title} className="principle" delay={i * 0.08}>
                <span className="icon-box">
                  <p.icon />
                </span>
                <div>
                  <h3 className="principle__title">{p.title}</h3>
                  <p className="principle__text">{p.text}</p>
                </div>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
